import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { StreamService } from '@app/_services/masters/stream.service';
import { stream } from '@app/_models/stream';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { LogService } from '../../../_shared/log.service'

@Component({
  selector: 'app-stream-master-add',
  templateUrl: './stream-master-add.component.html',
  styleUrls: ['./stream-master-add.component.css']
})
export class StreamMasterAddComponent implements OnInit {

  stream = new stream();

  constructor(private eventService: LogService, private formBuilder: FormBuilder, private streamService: StreamService,
    private modalService: NgbModal, config: NgbModalConfig, private router: Router) { }

  streamForm: FormGroup;
  submitted = false;
  showModalBox: boolean = false;
  getresponse: any;
  strMessage:string;
  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;
  returnUrl;

  ngOnInit(): void {
    this.streamForm = this.formBuilder.group({
      streamName: ['', Validators.required]
    });
  }

  get f() { return this.streamForm.controls; }

  addStream() {
    this.submitted = true;

    if (this.streamForm.invalid) {
      return;
    }
    this.streamService.addStream(this.stream)
      .subscribe((response) => {
        if (response) {
          this.getresponse = response;
          if (this.getresponse.respMessage == "Success") {
            this.strMessage="Stream Added Successfully.";
            this.modalService.open(this.showModalBoxTemplate);
            var v = response;
          }
          else if (this.getresponse.respMessage == "Failure") {
            this.strMessage=this.getresponse.respData;
            this.modalService.open(this.showModalBoxTemplate);
            var v = response;
          }
        }

      },
        (err: any) => {
          var message = err;
        });
  }

  refresh(): void {
    this.modalService.dismissAll(this.showModalBoxTemplate);
    this.eventService.emit<string>('7');
  }
  goBack()
  {
    this.eventService.emit<string>('7');
  }
}
